import React, {
    FunctionComponent,
    useEffect,
    useState,
} from "react";
import styles from "./Integrations.module.css";
import Modal from "react-modal";
import { IoIosClose } from "react-icons/io";

import DropdownWithValue from "../DropDown/DropdownWithValue";

import Loading from "../Loading/Loading";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { useHistory, useLocation } from "react-router-dom";
import TextInput from "../TextInput/TextInput";
import { marginTop, themeColors } from "../theme";
import Label from "../Label";
import { motion } from "framer-motion";
import Backdrop from "../Backdrop/Backdrop";
import FacebookLogin from '@greatsumini/react-facebook-login';
import axios from 'axios';
import NewButton from "../NewComponents/NewButton/NewButton";
import { Box } from "@material-ui/core";
import { getFBForms, getFBPages, updateIntegration } from "../../Services/fbIntegration";
import IntegrationVerification from "../NewComponents/IntegrationVerification/IntegrationVerification";

type props = {
    close: () => void;
    open: boolean;
    user: any;
    authToken: any;
    theme: any;
    edit?: boolean;
    editData?: any
};

const dropIn = {
    hidden: {
        y: "-100vh",
        opacity: 1,
    },
    visible: {
        y: "0",
        opacity: 1,
        transition: {
            duration: 1,
            type: "spring",
            damping: 25,
            stiffness: 500,
        },
    },
};

const appId = '1124360148768951';

const IntegrationEditForm: FunctionComponent<props> = ({
    close,
    open,
    user,
    authToken,
    theme,
    edit,
    editData
}) => {
    const [load, setLoad] = useState(false);
    const [integrationName, setIntegrationName] = useState("");
    const [googleSheetUrl, setGoogleSheetUrl] = useState("");
    const [googleSheetId, setGoogleSheetId] = useState("");
    const [googleSheetName, setGoogleSheetName] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [sheetId, setSheetId] = useState("");
    const [sheetUrl, setSheetUrl] = useState("");
    const [integrationTypeSelected, setIntegrationTypeSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [timeIntervalSelected, setTimeIntervalSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [fbPageSelected, setFBPageSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [fbFormSelected, setFBFormSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [integrationTypeList, setIntegrationTypeList] = useState<
        Object[]
    >([
        { label: "GOOGLE SHEET", value: "GOOGLE SHEET" }
    ]);
    const [timeInterval, setTimeInterval] = useState<
        Object[]
    >([
        { label: "5 min", value: "5" },
        { label: "10 min", value: "10" },
        { label: "15 min", value: "15" },
        { label: "30 min", value: "30" },
        { label: "60 min", value: "60" }
    ]);
    const [fbPagesList, setFbPagesList] = useState<
        Object[]
    >([]);
    const [fbFormsList, setFbFormsList] = useState<
        Object[]
    >([]);
    const [fbPagesData, setFbPagesData] = useState<
        Object[]
    >([]);
    const [showGiveAcess, setShowGiveAcess] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dispatcher = useDispatch();
    const history = useHistory();
    const location: any = useLocation();

    useEffect(() => {
        if (edit && editData) {
            const modifyData: any = {};
            Object.keys(editData).forEach(key => {
                const newKey = key.replace(/ /g, "_");
                modifyData[newKey] = editData[key];
            });
            setIntegrationName(modifyData?.Integration_Name || "");
            setGoogleSheetUrl(modifyData?.Sheet_URL || "");
            setGoogleSheetId(modifyData?.Sheet_ID || "");
            setGoogleSheetName(modifyData?.Sheet_Name || "");
            setTimeIntervalSelected({ label: `${modifyData?.Time_Interval} min`, value: modifyData?.Time_Interval });
            setIntegrationTypeSelected({ label: "GOOGLE SHEET", value: "GOOGLE SHEET" });
        }
    }, [edit, editData]);

    useEffect(() => {
        const extractSheetId = (url: any) => {
            if (typeof url === 'string') {
                const regex = /\/d\/([a-zA-Z0-9-_]+)/;
                const matches = url.match(regex);
                return matches ? matches[1] : null;
            }
            return null;
        };

        // Extract the sheetId and set it in the state
        const id = extractSheetId(googleSheetUrl);
        if (id) {
            setSheetId(id);
        }
    }, [googleSheetUrl]);

    useEffect(() => {
        setGoogleSheetId(sheetId);
    }, [sheetId]);

    const customStyles = {
        content: {
            backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark, 
            color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
        },
    };
    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, maxHeight: "400px" }
// console.log("user.orgID",user.organization_id)
useEffect(() => {
    if (isDropdownOpen) {
        const dropdown = document.querySelector(`.${styles.dropdown}`);
        if (dropdown) {
            dropdown.scrollIntoView({ behavior: "smooth" });
        }
    }
}, [isDropdownOpen]);
    return (
        <>
            {load && <Loading />}
            {open && <Backdrop>
                <motion.div
                    key="modal"
                    className="card p-4 shadow rounded"
                    style={{
                        position: "absolute", minWidth: "400px",
                        ...containerStyles
                    }}
                    variants={dropIn}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <div className={styles.firstDiv}>
                        <h5>
                            Edit Integration
                        </h5>
                        <div className={styles.cross} onClick={close}>
                            <IoIosClose size={35} color={"#808080"} />
                        </div>
                    </div>
                    <div className={styles.line}></div>

                    <div style={{ overflowY: "auto" }}>
                        <div className={styles.box2}>
                            <div
                                className={styles.divide}
                                style={{ width: "100%" }}
                            >
                                <Label label="Integration Type" required={true} />
                                <div style={{ marginTop: "7px" }}>
                                    <DropdownWithValue
                                        option={integrationTypeList}
                                        selectedValue={integrationTypeSelected}
                                        setSelectedValue={(value) => {
                                            
                                        }}
                                        disable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={styles.box2}>
                            <div
                                className={styles.divide}
                                style={{ width: "100%" }}
                            >
                                <Label label="Integration Name" required={true} />
                                <div>
                                    <TextInput
                                        title={"Enter name"}
                                        style={{ backgroundColor: "#fff" }}
                                        value={integrationName}
                                        disabled
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIntegrationName(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {
                            integrationTypeSelected.value === "FB LEADS" ? (
                                <>
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <FacebookLogin
                                                appId={appId}
                                                initParams={{
                                                    version: 'v10.0',
                                                }}
                                                scope='pages_read_engagement,pages_manage_metadata,pages_show_list,ads_management,leads_retrieval'
                                                style={{
                                                    backgroundColor: '#4267b2',
                                                    color: '#fff',
                                                    padding: '0.5rem',
                                                    border: 'none',
                                                    borderRadius: '0.25rem',
                                                }}
                                                onSuccess={(response) => {
                                                    setAccessToken(response.accessToken);
                                                    getFBPages(response.userID, response.accessToken, setFbPagesList, setFbPagesData);
                                                }}
                                                onFail={(error) => {
                                                    console.log('FB Login Failed!', error);
                                                }}
                                                onProfileSuccess={(response) => {
                                                    console.log('FB Get Profile Success!', response);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Select Page" required={true} />
                                            <div style={{ marginTop: "7px" }}>
                                                <DropdownWithValue
                                                    option={fbPagesList}
                                                    selectedValue={fbPageSelected}
                                                    setSelectedValue={(value) => {
                                                        setFBPageSelected(value);
                                                        getFBForms(value.value, fbPagesData, setFbFormsList)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Select Form" required={true} />
                                            <div style={{ marginTop: "7px" }}>
                                                <DropdownWithValue
                                                    option={fbFormsList}
                                                    selectedValue={fbFormSelected}
                                                    setSelectedValue={(value) => {
                                                        setFBFormSelected(value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Google Sheet URL" required={true} />
                                            <div>
                                                <TextInput
                                                    title={"Enter URL"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    value={googleSheetUrl}
                                                    disabled
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGoogleSheetUrl(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Google Sheet Id" required={true} />
                                            <div>
                                                <TextInput
                                                    title={"Enter URL"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    value={googleSheetId}
                                                    disabled
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGoogleSheetUrl(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Sheet Name" required={true} />
                                            <div>
                                                <TextInput
                                                    title={"Enter Sheet Name"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    value={googleSheetName}
                                                    disabled
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGoogleSheetName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Time Interval" required={true} />
                                            <div style={{ marginTop: "7px" }}>
                                                <DropdownWithValue
                                                    option={timeInterval}
                                                    selectedValue={timeIntervalSelected}
                                                    setSelectedValue={(value) => {
                                                        setTimeIntervalSelected(value);
                                                    }}
                                                    direction="top"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </div>
                    <div className={styles.line}></div>
                    <NewButton title="Save" 
                    onClick={()=>{
                        integrationTypeSelected.value === "FB LEADS" ?
                        console.log("Edit FB Integration")
                        :
                        console.log("Edit Google Sheet Integration")
                        updateIntegration(integrationName, user.organization_id, {
                            "google_sheet_batch_interval": timeIntervalSelected.value,
                            "google_sheet_name":googleSheetName,
                            "integration_status": "INACTIVE"
                        }, dispatcher, setLoad);
                        // setShowGiveAcess(true)
                    }}
                    style={{marginTop:"1rem"}}
                    />
                </motion.div>
            </Backdrop>}
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        authToken: state.authToken,
        theme: state.theme
    };
};

export default connect(mapStateToProps)(IntegrationEditForm);
